<template>
    <div>
        <div style="display: flex; flex-flow: column;">
            <div>
                <EntregasComponent :propPcm="propPcm" :idProjeto="propProjeto.id" :isAuditor="isAuditor"
                    :isGerente="isGerente" :idUsuario="idUsuario" :propEntregas="entregas"
                    :propEntregaSelecionada="entregaSelecionada" :destaque-entrega-id="destaqueEntregaId"
                    :somente-leitura="somenteLeitura"
                    :carregando="carregandoEntregas" @mudarEntrega="mudarEntrega" />
            </div>
        </div>
        <!-- <div class="margem alinha-centro">
            <button class="acao-secundaria botaoGantt" @click="showGrafico = true"> Gerenciar Tarefas</button>
        </div> -->
        <ModalGraficoSprints :mostrar="showGrafico" :entrega-selecionada="entregaSelecionada" :sprints="sprints"
            :is-auditor="isAuditor" :is-coordenador="isCoordenador" @fechar="showGrafico = false; getSprints()" />
        <p v-if="!carregandoEntregas && !entregaSelecionada?.id" class="estado-sem-entrega alinha-centro">
            <span class="chip bg-cinza">Selecione ou crie um pacote de trabalho para visualizar backlogs e sprints</span>
        </p>
        <template v-if="entregaSelecionada?.id">
        <div v-for="(sprint, index) in sprints" :key="index" style="margin-top: 1rem;">
            <p v-if="entregaConcluida && index === 0" class="chip bg-sucesso aviso-entrega-concluida">
                Pacote de trabalho concluído — sprints e tarefas somente leitura
            </p>
            <div class="bloco margem" v-if="this.sprints"
                :style="{ 'background-color': (index === 0 ? 'var(--cor-cinza)' : '') }">
                <div style="display: flex; justify-content: space-between">
                    <div :style="{ 'visibility': (index == 0 ? 'hidden' : '') }">
                        <HPStatusComponent :item="sprint" :somarHP="somarHP"
                            @filtrar="status => sprint.filtrar = status" />
                        <i @click="sprint.ocultar = !sprint.ocultar ?? true" title="Ocultar Sprint"
                            :class="sprint.ocultar ? 'bi-eye' : 'bi-eye-slash'" style="font-size: 20px"></i>
                    </div>
                    <div style="text-align: center;">
                        <h2 style="margin-bottom: 0;"> {{ sprint.nome }} </h2>
                        <span
                            @click="sprint.filtrar?.includes('atrasadas') ? sprint.filtrar = null : sprint.filtrar = ['atrasadas']"
                            class="bg-erro qtdTarefasAtrasadas"
                            v-if="contarTarefasAtrasadas(sprint.backlogs) && index !== 0"> {{
                                contarTarefasAtrasadas(sprint.backlogs) }}</span>
                    </div>
                    <div class="alinha-v">
                        <div :style="{ 'visibility': index === 0 ? 'hidden' : '' }"
                            class="statusSprint alinha-v alinha-centro" :class="{
                                'pendente': !sprint.dtInicio && !sprint.dtTermino,
                                'andamento': sprint.dtInicio && sprint.dtTermino,
                                'concluida': !sprint.dtInicio && sprint.dtTermino
                            }">
                            <strong v-if="sprint.dtInicio"> {{ abreviarMes(sprint.dtInicio.slice(0, 10)) }} </strong>
                            <i v-if="sprint.dtInicio && sprint.dtTermino" class="bi-arrow-right"></i>
                            <strong v-if="sprint.dtTermino"> {{ abreviarMes(sprint.dtTermino.slice(0, 10)) }} </strong>
                            <i :class="{
                                'bi-stop-circle-fill': !sprint.dtInicio && !sprint.dtTermino,
                                'bi-fast-forward-circle-fill': sprint.dtInicio && sprint.dtTermino,
                                'bi-check-circle-fill': !sprint.dtInicio && sprint.dtTermino
                            }"></i>
                        </div>
                        <OptionsSprint v-if="podeEditar && (isCoordenador || isAuditor) && index !== 0" :item="sprint"
                            @iniciarSprint="abrirModalEditarSprint" @editarDatas="abrirModalEditarSprint"
                            @apagarSprint="apagarSprint" />
                    </div>
                </div>
                <div style="display: flex; flex-flow: column" v-if="!sprint.ocultar">
                    <table class="tabela">
                        <tbody>
                            <tr>
                                <th v-if="podeEditar && (isCoordenador || isAuditor) && index != 0"></th>
                                <th style="max-width: 8rem;">Código</th>
                                <th>Descrição</th>
                                <th v-if="index !== 0">H.P.</th>
                                <th>{{ index == 0 ? 'Solicitante' : 'Responsável' }}</th>
                                <th v-if="index !== 0">Início Previsto</th>
                                <th v-if="index !== 0">Fim Previsto</th>
                                <th v-if="index !== 0">Status</th>
                                <th></th>
                            </tr>
                        </tbody>
                        <draggable :list="sprint.backlogs" group="backlogs" itemKey="id" :scroll-sensitivity="150"
                            animation="200"
                            @change="(event) => event.added ? atualizarTarefa(event.added.element.id, { sprint_id: sprint.id }) : null"
                            :force-fallback="true" tag="tbody" handle=".handle-drag" @start="onDragStart"
                            @end="onDragEnd"
                            :disabled="!podeEditar || (!isCoordenador && (index === 0 ? sprint.dtTermino : !isAuditor))">
                            <template #item="{ element }">
                                <tr :data-tarefa-id="element.id" :data-parente-id="element.parente_id || undefined"
                                    :class="{ 'destaque-tarefa': destaqueTarefaId != null && String(element.id) === String(destaqueTarefaId) }"
                                    :style="{ 'display': (mostrarTarefaOuNao(sprint, element)) ? '' : 'none' }">
                                    <td class="handle-drag"
                                        v-if="podeEditar && (isCoordenador || isAuditor) && index != 0">
                                        <i class="bi-list"></i>
                                    </td>
                                    <td style="max-width: 8rem !important">
                                        <div class="tarefa-cabecalho" v-if="element.parente_id">
                                            <strong>{{ encontrarAscendente(element.parente_id)?.codigo }}</strong>
                                        </div>

                                        <span style="white-space: nowrap;"> {{ element.codigo }}</span>

                                        <!-- <div class="tarefa-cabecalho"
                                            v-if="sprint.nome === 'Backlogs' && encontrarDescendente(element.id).length > 0">
                                            <ul style="list-style: none;margin: none; width: 100%;">
                                                <li v-for="t in encontrarDescendente(element.id)" :key="t.id">
                                                    <strong>{{ t.codigo }}</strong>
                                                </li>
                                            </ul>
                                        </div> -->
                                    </td>
                                    <td @click.stop @click="podeEditar ? abrirModalEditarTarefa(element) : null"
                                        style="text-align: left;"
                                        :style="{ 'max-width': index !== 0 ? '12rem' : '54rem' }"
                                        :title="element.descricao">
                                        <div class="alinha-v">
                                            <div :title="element.descricao" :class="{ 'descTarefa': index !== 0 }">
                                                {{ element.descricao }} </div>
                                            <i v-if="element.anexos.length > 0" style="font-size: 18px;"
                                                title="Esta tarefa possui um anexo" class="bi-paperclip"></i>
                                        </div>
                                    </td>
                                    <td v-if="index !== 0">
                                        <select v-model="element.HP" class="HP"
                                            :disabled="!podeEditar || (!isCoordenador && !isAuditor && (index === 0 ? (!isPO && !this.isEntregaPO) : true))"
                                            @click.stop @change.stop="atualizarTarefa(element.id, { HP: element.HP })">
                                            <option hidden :value="element.HP">{{ element.HP }}</option>
                                            <option hidden>0</option>
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>5</option>
                                            <option>8</option>
                                            <option>13</option>
                                            <option>21</option>
                                            <option>34</option>
                                            <option>55</option>
                                            <option>89</option>
                                            <option>144</option>
                                            <option>233</option>
                                        </select>
                                    </td>
                                    <td>
                                        <AutoCompleteSelect
                                            :key="`${element.id}-${element.responsavel_id}-${usuarios.length}`"
                                            v-model="element.responsavel_id"
                                            :items="buildItemsUsuarios(index, element.responsavel_id)"
                                            :fallback-label="element.responsavel"
                                            placeholder="Responsável"
                                            :disabled="!podeEditar || (!isCoordenador && !isAuditor && (index === 0 ? (!isPO && !this.isEntregaPO) : true))"
                                            @change="(id) => atualizarTarefa(element.id, { responsavel_id: id })" />
                                    </td>
                                    <td v-if="index !== 0">
                                        <input
                                            :disabled="!podeEditar || (!isCoordenador && !isAuditor && (index === 0 ? (!isPO && !this.isEntregaPO) : true))"
                                            type="date" :min="entregaSelecionada.dtInicio"
                                            @change="atualizarTarefa(element.id, { dtInicio: montarDataHora(element.dtInicio) })"
                                            v-model="element.dtInicio">
                                    </td>
                                    <td v-if="index !== 0">
                                        <div class="fim-previsto">
                                            <div class="alinha-v" style="gap: 10px;">
                                                <input
                                                    :disabled="!podeEditar || (!isCoordenador && !isAuditor && (index === 0 ? (!isPO && !this.isEntregaPO) : true))"
                                                    type="date" :min="element.dtInicio || entregaSelecionada.dtInicio"
                                                    @change="atualizarTarefa(element.id, { dtFim: montarDataHora(element.dtFim) })"
                                                    v-model="element.dtFim">
                                                <i v-if="element.dtFim && (hoje > element.dtFim) && element.status !== 'Concluído' && element.status !== 'Cancelada'"
                                                    class="bi-exclamation-diamond-fill txt-erro"
                                                    style="font-size: 18px; margin-right: .2rem"
                                                    title="Tarefa Atrasada"></i>
                                            </div>
                                            <span v-if="exibirFimPrevistoOriginal(element, element.dtFim)"
                                                class="chip bg-erro fim-previsto-original"
                                                :title="tituloFimPrevistoOriginal(element)">
                                                Original: {{ formatarDataBr(fimPrevistoOriginal(element)) }}
                                            </span>
                                        </div>
                                    </td>
                                    <td v-if="index !== 0">
                                        <BarraProgresso :propItem="element" :idUsuario="idUsuario"
                                            :isAuditor="podeEditar && (index === 0 ? (isPO || this.isEntregaPO) : isAuditor)"
                                            :isCoordenador="podeEditar && isCoordenador" exigir-responsavel
                                            @editarStatus="atualizarTarefa" />
                                    </td>
                                    <td>
                                        <div v-if="podeEditar" class="optionsTarefas">
                                            <OptionsTarefa :propTarefa="element"
                                                :isAuditor="index === 0 ? (isPO || this.isEntregaPO) : isAuditor"
                                                :pode-criar-tarefa="sprint.nome === 'Backlogs'"
                                                @criarTarefa="abrirModalCriarTarefa" :isCoordenador="isCoordenador"
                                                @editarTarefa="abrirModalEditarTarefa"
                                                @apagarTarefa="solicitarExclusaoTarefa" />
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </draggable>
                    </table>
                    <br>
                    <div v-if="podeEditar && (isCoordenador || isAuditor || (index === 0 && (isPO || isEntregaPO))) && (index === 0 ? !sprint.dtTermino : true)"
                        :id="sprint.id" class="alinha-v inputNovaTarefa">
                        <strong> {{ index === 0 ? codigoNovaHistoriaUsuario : codigoNovaTarefa }} </strong>
                        <input type="text" :placeholder="index === 0 ? 'Nova História de Usuário' : 'O que será feito?'"
                            v-model="novaTarefa.descricao" :id="'inputNovaTarefa' + sprint.id"
                            @keyup.enter="criarTarefa(sprint.id, index !== 0)">
                    </div>
                </div>
            </div>
            <br>
            <div v-if="podeEditar && index === 0 && (isCoordenador || isAuditor)">
                <button @click="criarNovaSprint" class="acao-secundaria"> Adicionar Sprint</button>
            </div>
        </div>
        </template>
    </div>
    <ModalEditarTarefa :isAuditor="isAuditor" :isCoordenador="isCoordenador || isPO || isEntregaPO || isGerente"
        :propTarefa="tarefaEditada" :usuarios="usuarios" :subordinados="subordinados" :todasTarefas="todasTarefas"
        v-if="showModal && tipoModal === 1" @fecharModal="showModal = false, getSprints()"
        @definirDatasReais="definirDatasReais" />
    <ModalEditarSprint v-if="showModal && tipoModal === 2" :propSprint="sprintEditada" @fecharModal="showModal = false"
        @atualizarSprint="getSprints, showModal = false" />

    <ModalTarefasSemData v-if="tarefasSemData.length > 0 && !alertaVisualizado" :propTarefas="tarefasSemData"
        @fecharModal="alertaVisualizado = true" @atualizaTarefa="atualizarTarefa"
        :propEntregaSelecionada="entregaSelecionada" />

    <ModalCriarTarefa v-if="historiaSelect" :propHistoria="historiaSelect" :propSprints="sprints"
        :propUsuarios="usuarios" :propSubordinados="subordinados" @fechar="historiaSelect = null"
        @criarTarefa="criarTarefaDeHist" />

    <ModalConfirmarExclusaoTarefa :mostrar="showModalExcluirTarefa" :codigo-tarefa="exclusaoCodigoTarefa"
        :quantidade-vinculos="exclusaoQuantidadeVinculos" :excluindo="exclusaoEmProgresso"
        @fechar="fecharModalExcluirTarefa" @confirmar="confirmarExclusaoTarefa" />
</template>
<script>
import draggable from "vuedraggable";
import { dataParaInput, dataHoraAgora, formatarDataBr, horaAgora } from "@/utils/date";
import { exibirFimPrevistoOriginal, fimPrevistoOriginal, tituloFimPrevistoOriginal } from "@/utils/fim-previsto-historico";
import { getSegundaASextaSemanaAtual, datasPrevistasDaSprint } from "@/utils/sprintGestao";
import {
    tarefaTemResponsavel,
    MENSAGEM_TAREFA_SEM_RESPONSAVEL,
    entregaEstaConcluida,
} from '@/utils/tarefaStatus';
import { useApiError } from "@/composables/useApiError";
import { consultarSetores } from "@/services/usuario-setor";
import { sso } from "roboflex-thalamus-sso-lib";
import serviceFunções from "@/services/serviceFunções";
import ModalGraficoSprints from '@/components/Modais/projetos/ModalGraficoSprints.vue';
import EntregasComponent from './EntregasComponent.vue';
import serviceProjetos from '@/services/serviceProjetos';
import HPStatusComponent from './HPStatusComponent.vue';
import OptionsSprint from './OptionsSprint.vue';
import OptionsTarefa from './OptionsTarefa.vue';
import BarraProgresso from '@/components/BarraProgresso.vue';
import ModalEditarTarefa from '@/components/Modais/projetos/ModalEditarTarefa.vue';
import ModalEditarSprint from '@/components/Modais/projetos/ModalEditarSprint.vue';
import ModalTarefasSemData from '@/components/Modais/projetos/ModalTarefasSemData.vue';
import ModalCriarTarefa from '@/components/Modais/projetos/ModalCriarTarefa.vue';
import ModalConfirmarExclusaoTarefa from '@/components/Modais/projetos/ModalConfirmarExclusaoTarefa.vue';
import AutoCompleteSelect from '@/components/AutoComplete/AutoCompleteSelect.vue';
import { buildProjectWorkUiContext } from '@/utils/project-work-ai-context';
export default {
    components: {
        draggable,
        ModalGraficoSprints,
        EntregasComponent,
        HPStatusComponent,
        OptionsSprint,
        BarraProgresso,
        OptionsTarefa,
        ModalEditarTarefa,
        ModalEditarSprint,
        ModalTarefasSemData,
        ModalCriarTarefa,
        ModalConfirmarExclusaoTarefa,
        AutoCompleteSelect,
    },

    name: "SprintsView",

    setup() {
        const somarHP = (dados) => {
            return serviceFunções.somarHP(dados);
        };

        const nomeEsobrenome = (nome) => {
            return serviceFunções.nomeEsobrenome(nome);
        };

        const abreviarMes = (dataString, mandarAno) => {
            return serviceFunções.abreviarMes(dataString, mandarAno);
        };

        const { handleError } = useApiError();
        return { somarHP, nomeEsobrenome, abreviarMes, handleApiError: handleError };
    },

    data() {
        return {
            modalCriarTarefaPorHist: false,
            showGrafico: false,
            novaEntrega: {},
            dadosProjeto: null,
            idUsuario: null,
            tarefaEditada: {},
            sprintEditada: {},
            showModal: false,
            tipoModal: null,
            sprints: null,
            usuarios: [],
            subordinados: [],
            entregas: [],
            carregandoEntregas: true,
            entregaSelecionada: null,
            novaTarefa: {},
            tarefasSemData: [],
            alertaVisualizado: false,
            historiaSelect: null,
            showModalExcluirTarefa: false,
            exclusaoIdTarefa: null,
            exclusaoCodigoTarefa: '',
            exclusaoQuantidadeVinculos: 0,
            exclusaoEmProgresso: false
        }
    },

    props: {
        propProjeto: {
            required: true,
        },
        isGerente: {
            required: true
        },
        isPO: {
            required: true
        },
        isAuditor: {
            required: true
        },
        propPcm: {
            default: {}
        },
        destaqueEntregaId: { type: [Number, String], default: null },
        destaqueSprintId: { type: [Number, String], default: null },
        destaqueTarefaId: { type: [Number, String], default: null },
        somenteLeitura: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        podeEditar() {
            return !this.somenteLeitura && !this.entregaConcluida
        },
        entregaConcluida() {
            return entregaEstaConcluida(this.entregaSelecionada)
        },
        hoje() {
            return dataParaInput(new Date().toISOString());
        },
        isCoordenador() {
            return this.entregaSelecionada?.coordenador_id === this.idUsuario || this.isGerente
        },
        isEntregaPO() {
            return this.entregaSelecionada?.po_id === this.idUsuario
        },
        todasTarefas() {
            var tarefas = (this.sprints || []).flatMap((item) => item.backlogs || [])
            tarefas.sort((a, b) => b.id - a.id);
            return tarefas
        },
        codigoNovaTarefa() {
            if (this.todasTarefas.length > 0) {
                const codigo = this.todasTarefas[0]?.codigo
                const match = (codigo && String(codigo).match(/\d+$/))
                const num = match ? parseInt(match[0], 10) + 1 : 1
                return `Tarefa - ${num}`
            } else {
                return 'Tarefa - 1'
            }
        },
        codigoNovaHistoriaUsuario() {
            if (this.todasTarefas.length > 0) {
                const codigo = this.todasTarefas[0]?.codigo
                const match = (codigo && String(codigo).match(/\d+$/))
                const num = match ? parseInt(match[0], 10) + 1 : 1
                return `História de usuário - ${num}`
            } else {
                return 'História de usuário - 1'
            }
        },
        dataHora() {
            return horaAgora();
        }
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
        this.idProjeto = this.propProjeto.id
    },

    async mounted() {
        this.getEntregas();
        this.getGerenteseSetor();
        this.getSubordinados();
    },

    methods: {
        assistantContext() {
            return buildProjectWorkUiContext(
                this.entregaSelecionada,
                this.sprints,
                this.entregaConcluida,
            )
        },
        encontrarDescendente(id, visitados = null) {
            const sid = id == null ? '' : String(id)
            if (!sid) return []

            const vistos = visitados ?? new Set()
            if (vistos.has(sid)) return []
            vistos.add(sid)

            const tarefas = []
            this.todasTarefas.forEach((t) => {
                if (!t || String(t.parente_id) !== sid) return
                tarefas.push(t)
                tarefas.push(...this.encontrarDescendente(t.id, vistos))
            })

            return tarefas
        },
        encontrarAscendente(id) {
            if (id == null) return undefined
            const sid = String(id)
            return this.todasTarefas.find(i => i && String(i.id) === sid)
        },
        async criarTarefaDeHist(novaTarefa) {
            if (!this.podeEditar) return
            if (!novaTarefa) {
                return
            }

            novaTarefa.codigo = this.codigoNovaTarefa;
            novaTarefa.status = "Pendente";

            try {
                var response = await serviceProjetos.criarTarefa(novaTarefa);

                novaTarefa.id = response.id
                novaTarefa.anexos = []
                novaTarefa.HP = 0

                const sprint = this.sprints.find(item => item.id === novaTarefa.sprint_id);
                if (!sprint) return
                if (!Array.isArray(sprint.backlogs)) sprint.backlogs = []
                novaTarefa.sprint = response.sprint ?? { id: sprint.id, nome: sprint.nome }
                sprint.backlogs.push(novaTarefa);
                this.historiaSelect = null
            } catch (error) {
                this.handleApiError(error);
            }
        },
        abrirModalCriarTarefa(hist) {
            if (!this.podeEditar) return
            this.historiaSelect = hist
        },
        verificarTarefasSemData() {
            if (this.isGerente || this.isCoordenador) {
                this.tarefasSemData = this.todasTarefas.filter(t => !t.dtFim && !t.codigo?.startsWith('História'))
            }
        },
        buildItemsUsuarios(index, responsavelAtualId) {
            // const podeVerTodos = (index === 0 && this.isPO || this.isEntregaPO) || this.isAuditor || this.isGerente;
            index
            const podeVerTodos = true

            if (podeVerTodos) return this.usuarios;

            return this.usuarios.filter(u =>
                this.subordinados.includes(u.id) || u.id === responsavelAtualId
            );
        },
        async getSubordinados() {
            var response = await serviceProjetos.getSubordinados(this.idUsuario)
            this.subordinados = response.map(i => i.usuario_id);
        },
        async getEntregas() {
            this.carregandoEntregas = true
            try {
                var response = await serviceProjetos.getEntregas(this.propProjeto.id);
                this.dadosProjeto = response?.projetos?.[0] ?? null;
                this.entregas = this.dadosProjeto?.entregas ?? [];
                const entregaId = this.destaqueEntregaId ? Number(this.destaqueEntregaId) : null;
                const entrega = entregaId ? this.entregas.find(e => e.id === entregaId) : null;
                this.entregaSelecionada = entrega ?? null;
                if (this.entregaSelecionada?.id) {
                    await this.getSprints();
                } else {
                    this.sprints = [];
                }
                const sprintId = this.destaqueSprintId ? Number(this.destaqueSprintId) : null;
                if (sprintId && this.sprints) {
                    const sprint = this.sprints.find(s => s.id === sprintId);
                    if (sprint) sprint.ocultar = false;
                }
                if (this.destaqueTarefaId) {
                    this.$nextTick(() => {
                        setTimeout(() => this.aplicarDestaqueTarefa(), 250);
                    });
                }
                this.notificarEntregaSelecionada();
            } finally {
                this.carregandoEntregas = false
            }
        },

        async getSprints() {
            if (!this.entregaSelecionada?.id) {
                this.sprints = [];
                return;
            }
            var response = await serviceProjetos.getSprints(this.entregaSelecionada.id);

            // Normaliza o responsavel_id: 0 → null
            response.sprints.forEach(sprint => {
                sprint.backlogs?.forEach(tarefa => {
                    if (tarefa.responsavel_id === 0) {
                        tarefa.responsavel_id = null;
                    }
                    if (tarefa.dtInicio) tarefa.dtInicio = dataParaInput(tarefa.dtInicio);
                    if (tarefa.dtFim) tarefa.dtFim = dataParaInput(tarefa.dtFim);
                    if (tarefa.dtInicioReal) tarefa.dtInicioReal = dataParaInput(tarefa.dtInicioReal);
                    if (tarefa.dtFimReal) tarefa.dtFimReal = dataParaInput(tarefa.dtFimReal);
                });
            });

            // Mantém a ordenação original
            this.sprints = response.sprints.sort((a, b) => {
                if (a.nome === 'Backlogs') return -1;
                if (b.nome === 'Backlogs') return 1;
                return b.id - a.id;
            });

            this.sprints[0].filtrar = ['Em andamento', 'Em andamento 25%', 'Em andamento 50%', 'Em andamento 75%', 'Pendente']

            this.verificarTarefasSemData()
        },

        aplicarDestaqueTarefa() {
            const id = this.destaqueTarefaId != null && this.destaqueTarefaId !== '' ? String(this.destaqueTarefaId) : null;
            if (!id) return;
            const limparQuery = () => {
                if (this.$route?.query?.destaque_tarefa_id != null) {
                    const query = { ...this.$route.query };
                    delete query.destaque_tarefa_id;
                    delete query.entrega_id;
                    delete query.sprint_id;
                    this.$router.replace({ path: this.$route.path, params: this.$route.params, query: Object.keys(query).length ? query : undefined });
                }
            };
            const buscarLinha = () => {
                const root = this.$el;
                const query = (sel) => root?.querySelector?.(sel) ?? document.querySelector(sel);
                const linhaComId = query(`tr[data-tarefa-id="${id}"]`);
                if (!linhaComId) return null;
                const ehTarefa = linhaComId.hasAttribute('data-parente-id');
                if (ehTarefa) return linhaComId;
                const tarefaFilha = query(`tr[data-parente-id="${id}"]`);
                return tarefaFilha || linhaComId;
            };
            const tentarScroll = (tentativa = 0) => {
                const el = buscarLinha();
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    setTimeout(limparQuery, 3000);
                    return;
                }
                if (tentativa < 35) {
                    setTimeout(() => tentarScroll(tentativa + 1), 120);
                } else {
                    setTimeout(limparQuery, 500);
                }
            };
            this.$nextTick(async () => {
                await this.$nextTick();
                tentarScroll(0);
            });
        },
        mudarEntrega(entrega) {
            this.entregaSelecionada = entrega;
            if (entrega?.id) {
                this.getSprints();
            } else {
                this.sprints = [];
            }
            this.notificarEntregaSelecionada();
        },
        notificarEntregaSelecionada() {
            const id = this.entregaSelecionada?.id ?? null;
            this.$emit('entrega-selecionada', id);
        },
        async fecharBacklog(id) {
            var payload = {
                dtInicio: null,
                dtTermino: dataParaInput(new Date().toISOString()),
            }
            if (confirm('Tem certeza de que deseja fechar o backlog?')) {
                await serviceProjetos.atualizarSprint(id, payload);
                this.getSprints()
            }
        },
        mostrarTarefaOuNao(item, element) {
            const hojeVal = this.hoje;
            const dtFim = element.dtFim ?? null;
            if (item.filtrar && item.nome !== 'Backlogs') {
                if (!item.filtrar?.includes('atrasadas')) {
                    return item.filtrar?.includes(element.status)
                } else {
                    return dtFim && dtFim < hojeVal && element.status !== "Concluído" && element.status !== 'Cancelada';
                }
            }
            else {
                return true
            }
        },
        contarTarefasAtrasadas(tarefas) {
            const hojeVal = this.hoje;

            const atrasadas = tarefas.filter(tarefa => {
                const dtFim = tarefa.dtFim ?? null;
                return dtFim && dtFim < hojeVal && tarefa.status !== "Concluído" && tarefa.status !== 'Cancelada';
            }).length;

            if (atrasadas === 0) {
                return null;
            } else if (atrasadas === 1) {
                return `1 tarefa atrasada`;
            } else {
                return `${atrasadas} tarefas atrasadas`;
            }
        },

        buscarTarefaPorId(idTarefa) {
            for (const sprint of this.sprints || []) {
                const tarefa = (sprint.backlogs || []).find((t) => t.id == idTarefa)
                if (tarefa) return tarefa
            }
            return null
        },

        formatarDataBr,
        fimPrevistoOriginal,
        exibirFimPrevistoOriginal,
        tituloFimPrevistoOriginal,

        montarDataHora(valor) {
            return dataParaInput(valor) || null;
        },

        async atualizarTarefa(idTarefa, payload) {
            if (!this.podeEditar) return
            const tarefa = this.buscarTarefaPorId(idTarefa)
            if ('status' in payload) {
                if (tarefa && !tarefaTemResponsavel(tarefa)) {
                    window.alert(MENSAGEM_TAREFA_SEM_RESPONSAVEL)
                    if (payload.statusAnterior != null) {
                        tarefa.status = payload.statusAnterior
                    }
                    return
                }
                if (tarefa && payload.status != null) {
                    tarefa.status = payload.status
                }
            }
            const dados = { ...payload }
            delete dados.statusAnterior
            dados.usuario_id = this.idUsuario;
            try {
                const response = await serviceProjetos.atualizarTarefa(idTarefa, dados);
                this.aplicarTarefaAtualizada(idTarefa, response?.tarefa)
                if ('status' in payload) {
                    await this.definirDatasReais(idTarefa, payload.status);
                }
            } catch (error) {
                this.handleApiError(error);
                // Recarrega para descartar da tela o valor que não foi persistido.
                await this.getSprints();
            }
        },

        aplicarTarefaAtualizada(idTarefa, atualizada) {
            if (!atualizada) return
            const tarefa = this.buscarTarefaPorId(idTarefa)
            if (!tarefa) return
            if (atualizada.status != null) tarefa.status = atualizada.status
            if ('dtInicioReal' in atualizada) tarefa.dtInicioReal = dataParaInput(atualizada.dtInicioReal) || null
            if ('dtFimReal' in atualizada) tarefa.dtFimReal = dataParaInput(atualizada.dtFimReal) || null
            const logs = atualizada.logs_fim_previsto ?? atualizada.logsFimPrevisto
            if (logs) tarefa.logs_fim_previsto = logs
        },

        definirDatasReais(idTarefa, status) {

            const dataHora = dataHoraAgora();
            let payload = { usuario_id: this.idUsuario };

            if (['Em andamento', 'Em andamento 25%', 'Em andamento 50%', 'Em andamento 75%'].includes(status)) {
                payload.dtInicioReal = dataHora;
                payload.dtFimReal = null;
            } else if (status === 'Concluído') {
                payload.dtFimReal = dataHora;
            } else if (status === 'Pendente') {
                payload.dtInicioReal = null;
                payload.dtFimReal = null;
            }

            if (Object.keys(payload).length > 1) {
                return this.atualizarTarefa(idTarefa, payload);
            }

        },

        async getGerenteseSetor() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.usuarios = usuarios;
                this.setores = setores;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        abrirModalEditarTarefa(tarefa) {
            if (!this.podeEditar) return
            this.tarefaEditada = tarefa;
            this.tipoModal = 1;
            this.showModal = true
        },

        async abrirModalEditarSprint(sprint, ação) {
            if (!this.podeEditar) return

            if (ação === 'finalizar') {
                var payload = {
                    dtInicio: null,
                    dtTermino: dataParaInput(new Date().toISOString())
                }
                await serviceProjetos.atualizarSprint(sprint.id, payload);
                this.getSprints()

            } else {
                this.sprintEditada = sprint
                this.tipoModal = 2;
                this.showModal = true
            }
        },

        async criarNovaSprint() {
            if (!this.podeEditar) return
            var nomeSprint = "Sprint - 1";
            if (this.sprints.at(-1).nome !== "Backlogs") {
                nomeSprint = 'Sprint - ' + (parseInt((this.sprints[1].nome).match(/\d+$/)[0]) + 1);
            }

            const { inicio, fim } = getSegundaASextaSemanaAtual();
            var payload = {
                nome: nomeSprint,
                projeto_id: this.idProjeto,
                entrega_id: this.entregaSelecionada.id,
                dtInicio: inicio,
                dtTermino: fim,
            };
            await serviceProjetos.adicionarSprint(payload);
            this.getSprints();
        },

        async criarTarefa(idSprint, isSprint) {
            if (!this.podeEditar) return
            var descricao = this.novaTarefa.descricao

            if (!descricao) {
                return
            }

            const sprint = this.sprints.find(item => item.id === idSprint);
            var payload = {
                sprint_id: idSprint,
                codigo: isSprint ? this.codigoNovaTarefa : this.codigoNovaHistoriaUsuario,
                descricao: descricao,
                status: "Pendente"
            };

            if (isSprint && sprint) {
                const { inicio, fim } = datasPrevistasDaSprint(sprint);
                payload.dtInicio = inicio;
                payload.dtFim = fim;
            }

            try {
                var response = await serviceProjetos.criarTarefa(payload);

                payload.id = response.id
                payload.anexos = []
                payload.HP = response.HP ?? 0
                payload.responsavel_id = response.responsavel_id ?? null
                payload.logs_fim_previsto = response.logs_fim_previsto ?? []
                if (isSprint && sprint) {
                    payload.dtInicio = payload.dtInicio ?? null;
                    payload.dtFim = payload.dtFim ?? null;
                }
                if (!sprint) return
                if (!Array.isArray(sprint.backlogs)) sprint.backlogs = []
                payload.sprint = response.sprint ?? { id: sprint.id, nome: sprint.nome }
                sprint.backlogs.push(payload);
                this.novaTarefa = {}
            } catch (error) {
                this.handleApiError(error);
            }
        },

        /** IDs das subtarefas (pós-ordem) e por último a raiz, para respeitar a hierarquia na API. */
        idsExclusaoTarefaEmOrdemSegura(rootId) {
            const all = this.todasTarefas
            const descendentes = []
            const visitados = new Set()
            const walk = (parentId) => {
                const pid = parentId == null ? '' : String(parentId)
                if (!pid || visitados.has(pid)) return
                visitados.add(pid)
                const filhos = all.filter((t) => t && String(t.parente_id) === pid)
                for (const f of filhos) {
                    walk(f.id)
                    descendentes.push(f.id)
                }
            }
            walk(rootId)
            return [...descendentes, rootId]
        },

        solicitarExclusaoTarefa(idTarefa) {
            if (!this.podeEditar) return
            const tarefa = this.todasTarefas.find(t => t && String(t.id) === String(idTarefa))
            const vinculos = this.encontrarDescendente(idTarefa)
            this.exclusaoIdTarefa = idTarefa
            this.exclusaoCodigoTarefa = tarefa?.codigo ?? `Tarefa #${idTarefa}`
            this.exclusaoQuantidadeVinculos = vinculos.length
            this.showModalExcluirTarefa = true
        },

        fecharModalExcluirTarefa() {
            if (this.exclusaoEmProgresso) return
            this.showModalExcluirTarefa = false
            this.exclusaoIdTarefa = null
        },

        async confirmarExclusaoTarefa() {
            if (!this.podeEditar) return
            const idTarefa = this.exclusaoIdTarefa
            if (idTarefa == null) return
            this.exclusaoEmProgresso = true
            try {
                const ordem = this.idsExclusaoTarefaEmOrdemSegura(idTarefa)
                for (const tid of ordem) {
                    await serviceProjetos.excluirTarefa(tid, this.idUsuario)
                }
                this.showModalExcluirTarefa = false
                this.exclusaoIdTarefa = null
                await this.getSprints()
            } catch (error) {
                this.handleApiError(error)
            } finally {
                this.exclusaoEmProgresso = false
            }
        },

        async apagarSprint(id) {
            if (!this.podeEditar) return
            await serviceProjetos.apagarSprint(id, this.idUsuario);
            this.getSprints()
        },

        onDragStart(evt) {
            const tr = evt.item;
            tr.classList.add('tr--dragging');
        },
        onDragEnd(evt) {
            const tr = evt.item;
            tr.classList.remove('tr--dragging');
        }
    }
}
</script>
<style scoped>
.estado-sem-entrega {
    margin: 1.25rem 0 0.5rem;
}

.tarefa-cabecalho {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    color: #555;
    margin-bottom: 4px;
    /* separa do conteúdo da célula */
}

.tarefa-cabecalho i {
    font-size: 0.9rem;
    color: #666;
}

.tarefa-cabecalho .nome-tarefa {
    font-weight: 500;
}



.descTarefa {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis
}

.fim-previsto {
    display: flex;
    flex-direction: column;
}

/* Espaço espelhado acima do input: a linha cresce e o input segue centralizado. */
.fim-previsto:has(.fim-previsto-original) {
    padding-top: 28px;
    gap: 4px;
}

/* Sem a margem negativa da tabela, senão o chip invade a altura visual do campo. */
.fim-previsto:has(.fim-previsto-original) input[type="date"] {
    margin: 0;
}

.fim-previsto-original {
    align-self: flex-start;
    margin: 0;
    line-height: 20px;
    white-space: nowrap;
}


.botaoGantt {
    background-color: var(--cor-cinza2);
}

.handle-drag {
    font-size: 20px;
    color: var(--cor-fonte);
    cursor: grab;
}

.handle-drag {
    cursor: grab;
}

.tr--dragging,
.tr--dragging .handle-drag {
    cursor: grabbing !important;
}

.inputNovaTarefa {
    strong {
        border: 1px solid var(--cor-separador);
        border-radius: 5px;
        padding: 0.3rem;
        width: fit-content;
        white-space: nowrap;
        padding: 0 .5rem;
        text-align: center;
        align-content: center;
        height: 3rem;
    }

    input {
        height: 3rem;
        margin: 0;
        margin-left: 5px;
        background-color: transparent !important;
    }

    input[type=date] {
        width: fit-content;
        background-color: transparent !important;
    }
}


.optionsTarefas {
    visibility: hidden;
}

tr:hover .optionsTarefas {
    visibility: visible;
}

.statusSprint {
    width: 13rem;
    border: 1px solid;
    margin-right: 0.5rem;
    border-radius: 10px;

    i {
        font-size: 22px;
        margin-left: 1rem;
    }
}

.statusSprint.pendente {
    border-color: rgba(255, 145, 0, 0.8);

    i {
        color: rgba(255, 145, 0, 0.7);
    }
}

.statusSprint.andamento {
    border-color: rgba(0, 47, 255, 0.8);

    i {
        color: rgba(0, 47, 255, 0.7);
    }
}

.statusSprint.concluida {
    border-color: rgba(0, 255, 0, 0.8);

    i {
        color: rgba(0, 255, 0, 0.7);
    }
}

.anexos a i {
    display: none;
    color: var(--cor-erro);
    font-size: 14px;
}

.anexos a:hover i {
    display: inline;
}

.qtdTarefasAtrasadas {
    padding: 0 .5rem;
    border-radius: 6px;
}

.aviso-entrega-concluida {
    margin-bottom: 0.5rem;
}

.linha-tabela:hover {
    background-color: var(--cor-primaria-fraca);
}

* {
    user-select: none;
}

select:disabled,
textarea:disabled,
input:disabled {
    opacity: 1;
    cursor: not-allowed;
}

tr.destaque-tarefa {
    background-color: var(--cor-primaria-fraca, rgba(25, 118, 210, 0.15)) !important;
    animation: destaque-tarefa-pulse 1.5s ease-in-out 2;
}

@keyframes destaque-tarefa-pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.85;
    }
}
</style>